import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { isMemberFollowing } from '@/js/lib/api/v1/member';

export const useMemberStore = defineStore('member', () => {
  const followedMemberIds = ref<number[]>([]);
  async function getFollowedList(memberIds: number[]) {
    const followedList = await isMemberFollowing({ memberIds });
    followedMemberIds.value = followedList.filter((member) => member.liked === 1).map((member) => Number(member.memberId));
  }
  function addFollowedMemberId(memberId: number) {
    if (!followedMemberIds.value.includes(memberId)) {
      followedMemberIds.value.push(memberId);
    }
  }
  function removeFollowedMemberId(memberId: number) {
    const index = followedMemberIds.value.indexOf(memberId);
    if (index !== -1) {
      followedMemberIds.value.splice(index, 1);
    }
  }

  return { followedMemberIds: readonly(followedMemberIds), getFollowedList, addFollowedMemberId, removeFollowedMemberId };
});
